import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import {MyMess} from '../../../App';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { CircularProgress, makeStyles, TextField, Typography } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({ 
    spinner: {
      margin: 10
    },
    confirmText:{
        color: 'red'
    }
  }));
  

function makeRandString(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

 const reinitInfoInitState = {
    confirmTextInput:'',
    confirmTextError:'',
    confirmText:makeRandString(8)
 }

 export default function LicenseEditConfirmChange(props) {
    const classes = useStyles();
  const { onConfirm,onCancel, value: valueProp, licenseCode, open,oPlan,nPlan, ...other } = props; 
  const [isProcessing, setProcessing] = React.useState(false);


  let [reInitInfo, setReInitInfo] = useState(reinitInfoInitState) 
  
  const handleCancel = () => {    
    onCancel()
  };

  
  const changeHandler = e => {
   setReInitInfo({...reInitInfo, [e.target.name]: e.target.value})        
 }

 const handleConfirm = () => {
    if(reInitInfo.confirmTextInput != reInitInfo.confirmText){
        setReInitInfo({
            ...reInitInfo,
            confirmTextError:MyMess.signUp.notMatchPassword
        })
    }else{
        setReInitInfo(reinitInfoInitState);
        onConfirm();
    }
    
 }

 const planChangeMessage = () => {
  let pcMsg = MyMess.kopaproLicense.planChange;
  pcMsg = pcMsg.replace("#oPlan#" , MyMess.kopaproLicense.plan[oPlan])
  pcMsg = pcMsg.replace("#nPlan#" , MyMess.kopaproLicense.plan[nPlan])

   return pcMsg
 }

 const invalidChange = () => {
  let planValue = {
    su:1,
    bu:2,
    pm:3,
    et:4
  }

  let oPV = planValue[oPlan];
  let nPV = planValue[nPlan];

   return nPV < oPV;
 }

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"      
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title"></DialogTitle>
      {isProcessing &&  <CircularProgress className={classes.spinner} size={36} thickness={4} />}
      <DialogContent dividers>
      <form>   
      {!invalidChange() &&     
        <div>
          <Typography  variant="subtitle2" color="primary" gutterBottom>
              {planChangeMessage()} <br/>
               
              {MyMess.kopaproLicense.planChangeWarn1}<br/>
              {MyMess.kopaproLicense.planChangeWarn2}<br/>

              {MyMess.kopaproLicense.planChangeWarn3}<br/>
              
          </Typography>
          <Typography color="secondary">{reInitInfo.confirmText}</Typography>
        </div>
        }

      {invalidChange() &&     
        <Typography  variant="subtitle2" color="primary" gutterBottom>  
                 
              {planChangeMessage()} <br/>
              {MyMess.kopaproLicense.invalidPlanChange}<br/>        
        </Typography>
        }
        {!invalidChange() &&  
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="confirmTextInput"
            label={reInitInfo.confirmText}
            name="confirmTextInput"            
            autoFocus
            value={reInitInfo.confirmTextInput}      
            onChange={changeHandler} 
            error={reInitInfo.confirmTextError}   
            helperText={reInitInfo.confirmTextError}  
            
            //disabled={isSubmitting}
        />
        }
        </form>

      
      </DialogContent>
      <DialogActions>
        {!invalidChange() &&
          <Button onClick={handleConfirm} disabled={isProcessing} >
            {MyMess.general.confirm}
          </Button>
        }        
        <Button autoFocus onClick={handleCancel} disabled={isProcessing} >
            {MyMess.general.back}
        </Button>        
      </DialogActions>
    </Dialog>
  );
}

LicenseEditConfirmChange.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    oPlan: PropTypes.string.isRequired,      
    nPlan: PropTypes.string.isRequired    
};
